import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Button, Card, Row, Col, message, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { bg_button, bg_shadow, bg_text } from "constant/css";
import BankImageSelect from "./component/bankSelect";
import GetCompanyInfo from "functions/merchant/getCompanyInfo";
import EmailOTPValidation from "functions/validation/emailOTPvalidation";
import OtpInput from "react-otp-input";
import IBANCheck from "functions/validation/IBANCheck";
import CreateMerchant from "functions/merchant/createMerchant";
import { useLoading } from "context/loadingContext";
import CheckRegisterDuplicate from "functions/merchant/checkRegisterDuplicate";

const banks = [
  { label: "Хаан банк", value: "050000", img: "/bank/khan.png" },
  { label: "Төрийн банк", value: "340000", img: "/bank/state.png" },
  { label: "Голомт банк", value: "150000", img: "/bank/golomt.png" },
  { label: "Худалдаа хөгжлийн банк", value: "040000", img: "/bank/tdb.png" },
  { label: "Хас банк", value: "320000", img: "/bank/has.png" },
  { label: "Богд банк", value: "380000", img: "/bank/bogd.png" },
  { label: "Капитрон банк", value: "300000", img: "/bank/capitron.png" },
];
const pricingOptions = [
  {
    label: "Эхлэл багц",
    subtitle: "Бизнесээ эхлүүлж буй хэн бүхэнд зориулсан",
    price: "Сарын ₮99,000",
    condition: "Сарын 10 сая хүртэл борлуулалттай бизнес эрхлэгчдэд зориулав",
    value: "starter",
  },
  {
    label: "Өсөлт багц",
    subtitle: "Жижиг, дунд бизнес эрхлэгчдэд зориулсан",
    price: "Орлогын 2.4 хувь",
    condition:
      "Сарын 10-с 200 сая хүртэл борлуулалттай бизнес эрхлэгчдэд зориулав",
    value: "growth",
  },
  {
    label: "Байгууллагын багц",
    subtitle: "Том бизнес эрхлэгчдэд зориулсан",
    price: "Холбоо барих",
    condition: "Байгууллагын хэрэгцээ шаардлагад нийцүүлэн тохирно",
    value: "enterprise",
  },
];
const SignUp = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { showLoading, hideLoading } = useLoading();
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otp, setOtp] = useState();
  const [validOtp, setValidOtp] = useState("");
  const [otpExpireSec, setOtpExpireSec] = useState(60);
  const [isOtpExpired, setIsOtpExpired] = useState(false);
  const [otpValidated, setOtpValidated] = useState(false);
  const [accountValidated, setAccountValidated] = useState(null);
  const [pack, setPack] = useState("starter");
  const otpRefs = useRef([]);

  const [companyInfoName, setCompanyInfoName] = useState("Байгууллага нэр");
  const register = Form.useWatch("register", form);
  const accountNumber = Form.useWatch("accountNumber", form);
  const bankCode = Form.useWatch("bankCode", form);
  useEffect(() => {
    if (register && register.length === 7) {
      fetchCompany(register);
    }
  }, [register]);
  useEffect(() => {
    if (otp && otp.length === 4 && otp === validOtp) {
      setOtpValidated(true);
      message.success("Имэйл баталгаажсан.");
      setOtpModalOpen(false);
    }
  }, [otp]);

  const signUp = async () => {
    if (!otpValidated) {
      return message.error("Имэйл хаягаа баталгаажуулна уу.");
    }
    const values = form.getFieldsValue();
    if (!values.name || !values.register || !values.phone || !values.phone2) {
      return message.error("Бүртгүүлэхийн тулд бүх талбарыг бөглөнө үү.");
    }
    if (!accountValidated) {
      return message.error("Дансны дугаар шалгаагүй байна.");
    }
    const body = {
      ...values,
      spayFeePercent: pack === "growth" ? 2.4 : 0,
      feePercent: 0,
      userFee: 0,
      useFeeType: "FIXED",
      productTypeId: 1,
      pack: pack,
    };
    console.log("📦 SignUp body:", body);

    try {
      showLoading();
      const response = await CreateMerchant(body);
      if (response && response.id) {
        message.success(
          "Бүртгэл амжилттай. Бид таны Имэйл хаягаар системд нэвтрэх мэдээлэл илгээх болно."
        );
        localStorage.setItem("merchantUsername", values.email);
        navigate("/merchant");
      } else
        return message.error("Бүртгэл амжилтгүй боллоо. Дахин оролдоно уу.");
    } catch (e) {
      console.error("Error during signup:", e);
      return message.error("Бүртгэл хийхэд алдаа гарлаа.");
    } finally {
      hideLoading();
    }
  };

  useEffect(() => {
    if (otpModalOpen && otpExpireSec > 0) {
      const timer = setInterval(() => {
        setOtpExpireSec((sec) => {
          if (sec <= 1) {
            clearInterval(timer);
            setIsOtpExpired(true);
          }
          return sec - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [otpModalOpen]);
  useEffect(() => {
    setAccountValidated(null);
  }, [accountNumber, bankCode]);
  const fetchCompany = async (register) => {
    try {
      const companyInfo = await GetCompanyInfo(register);
      if (companyInfo) {
        checkRegisterDuplicate(register);
        setCompanyInfoName(companyInfo.name || "Байгууллага олдсонгүй");
      } else {
        setCompanyInfoName("Байгууллага олдсонгүй");
      }
    } catch (e) {
      console.error("Error fetching company info:", e);
    }
  };
  const checkRegisterDuplicate = async (register) => {
    if (!register || register.length !== 7) return;
    try {
      const response = await CheckRegisterDuplicate(register);
      console.log(response);
      if (!response || !response.success) {
        form.setFieldValue("register", null);
        setCompanyInfoName("Байгууллага олдсонгүй");
        message.error(`${register} регистрийн дугаар бүртгэлтэй байна.`);
      }
    } catch (e) {
      console.error("Error checking register duplicate:", e);
      // message.error("Регистрийн дугаар шалгахад алдаа гарлаа.");
    }
  };
  const checkAccount = async () => {
    if (!accountNumber || !bankCode)
      return message.error("Дансны дугаар болон банк сонгоно уу.");
    try {
      const response = await IBANCheck(accountNumber, bankCode);
      if (response && response.success && response.data && response.data.iban) {
        setAccountValidated(response.data);
      } else {
        setAccountValidated(null);
        return message.error("Дансны дугаар шалгахад алдаа гарлаа.");
      }
    } catch (e) {
      console.error("Error checking account:", e);
      return message.error("Данс шалгахад алдаа гарлаа.");
    }
  };
  const onSendOtp = async () => {
    setOtpValidated(false);
    const email = form.getFieldValue("email");
    if (!email) return message.error("Имэйл хаяг оруулна уу.");
    try {
      const response = await EmailOTPValidation(email); // backend call
      console.log("OTP response:", response);
      if (!response) message.error("Имэйл хаяг баталгаажуулахад алдаа гарлаа.");
      setValidOtp(response);
      setOtpModalOpen(true);
      setOtp(["", "", "", ""]);
      setOtpExpireSec(60);
      setIsOtpExpired(false);
      message.success("OTP илгээгдлээ.");
    } catch (err) {
      message.error("OTP илгээхэд алдаа гарлаа.");
    }
  };

  const onOtpConfirm = () => {
    const value = otp.join("");
    if (value.length !== 4) return message.error("4 оронтой код оруулна уу.");
    if (isOtpExpired) return message.error("Кодын хугацаа дууссан байна.");
    if (value === validOtp) {
      setOtpValidated(true);
      message.success("Имэйл баталгаажсан.");
      setOtpModalOpen(false);
    }
  };

  const onFinish = (values) => {
    console.log("📦 Submitted:", values);
    // signup backend logic
  };

  return (
    <div className="move-area flex justify-center items-center min-h-screen">
      <Card
        style={{ width: "600px", borderRadius: 20, padding: "30px" }}
        className={`${bg_shadow}`}
      >
        <div className="text-center mb-6">
          <span className={`${bg_text} text-2xl font-extrabold`}>
            Мерчант Бүртгүүлэх
          </span>
          <br />
          <span className={`${bg_text} text-sm font-semibold`}>
            Rapid, Reliable, Rewarding
          </span>
        </div>

        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={12}>
            <Col span={24}>
              <div className="flex items-center justify-center mb-4">
                <Form.Item
                  label="Имэйл"
                  name="email"
                  rules={[{ required: true, message: "Имэйл хаяг оруулна уу" }]}
                >
                  <Input
                    disabled={otpValidated}
                    className="w-[300px]"
                    suffix={
                      <Button
                        onClick={onSendOtp}
                        disabled={otpValidated}
                        size="small"
                        className={`${bg_button} text-white ${bg_shadow}`}
                      >
                        {otpValidated ? "Баталгаажсан" : "Код авах"}
                      </Button>
                    }
                  />
                </Form.Item>
              </div>
            </Col>
            {otpValidated && (
              <>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                  {pricingOptions.map((option) => {
                    const active = pack === option.value;
                    return (
                      <div
                        key={option.value}
                        onClick={() => setPack(option.value)}
                        className={`cursor-pointer border text-xs rounded-xl p-5 hover:shadow-md transition-all duration-300 ${
                          active
                            ? `${bg_shadow} ring-2 ring-teal-500 ${bg_button} text-white`
                            : "border-gray-200"
                        }`}
                      >
                        <div className="text-md font-bold">{option.label}</div>
                        <div
                          className={`text-[10px] mb-3 ${
                            active ? "text-gray-100" : "text-gray-500"
                          }`}
                        >
                          {option.subtitle}
                        </div>
                        <div className="text-md font-bold">{option.price}</div>
                        <div
                          className={`text-[10px] mt-1 ${
                            active ? "text-gray-100" : "text-gray-500"
                          }`}
                        >
                          {option.condition}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <Col span={12}>
                  <Form.Item
                    label="Мерчант нэр"
                    name="name"
                    rules={[
                      { required: true, message: "Мерчант нэр оруулна уу" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Регистрийн дугаар"
                    name="register"
                    rules={[{ required: true, message: "Регистр оруулна уу" }]}
                  >
                    <Input
                      suffix={
                        <span className="text-gray-400 text-sm">
                          {!companyInfoName.includes("Байгууллага") ? (
                            <span className={`${bg_text} font-bold`}>
                              {companyInfoName}
                            </span>
                          ) : (
                            <span className={`text-xs font-bold`}>
                              {companyInfoName}
                            </span>
                          )}
                        </span>
                      }
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Утасны дугаар"
                    name="phone"
                    rules={[
                      { required: true, message: "Утасны дугаар оруулна уу" },
                    ]}
                  >
                    <Input
                      prefix={<span className={`${bg_text}`}>+976 </span>}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Утасны дугаар 2"
                    name="phone2"
                    rules={[
                      { required: true, message: "Утасны дугаар оруулна уу" },
                    ]}
                  >
                    <Input
                      prefix={<span className={`${bg_text}`}>+976 </span>}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <BankImageSelect banks={banks} form={form} />
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="Дансны дугаар"
                    name="accountNumber"
                    z
                    rules={[
                      { required: true, message: "Дансны дугаар оруулна уу" },
                      {
                        min: 8,
                        message: "Хамгийн багадаа 8 оронтой байх ёстой",
                      },
                    ]}
                  >
                    <Input
                      prefix={
                        <Button
                          onClick={checkAccount}
                          className={`${bg_button} text-white`}
                        >
                          Шалгах
                        </Button>
                      }
                      suffix={
                        <div>
                          <span className={`${bg_text} text-sm font-semibold`}>
                            {accountValidated
                              ? `${accountValidated.name}`
                              : accountNumber && ""}
                          </span>
                        </div>
                      }
                    />
                  </Form.Item>
                </Col>

                <Col span={24} className="text-center mt-2">
                  <Form.Item>
                    <Button
                      onClick={signUp}
                      htmlType="submit"
                      type="primary"
                      className={`${bg_button}`}
                    >
                      Бүртгүүлэх
                    </Button>
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
        </Form>
      </Card>

      {/* OTP Modal */}
      <Modal
        open={otpModalOpen}
        onCancel={() => setOtpModalOpen(false)}
        footer={null}
        centered
        width={300}
        title="OTP баталгаажуулах код"
      >
        <div className="flex gap-2 justify-center my-4">
          <OtpInput
            value={otp}
            onChange={setOtp}
            inputType="number"
            numInputs={4}
            containerStyle={{
              width: "100%",
              marginBottom: 20,
              gap: 10,
              justifyContent: "space-between",
            }}
            inputStyle={{
              width: 100,
              borderRadius: 16,
              height: 50,
              fontSize: 18,
              fontWeight: "bold",
            }}
            renderInput={(props) => (
              <Input disabled={false} style={{}} {...props} />
            )}
          />
        </div>
        <div className="text-center text-sm mb-4">
          {isOtpExpired ? (
            <span className="text-red-500">Кодын хугацаа дууссан</span>
          ) : (
            <span>Код хүчинтэй хугацаа: {otpExpireSec} сек</span>
          )}
        </div>
        <div className="text-center">
          <Button
            type="primary"
            className={`${bg_button}`}
            onClick={onOtpConfirm}
            disabled={isOtpExpired}
          >
            Баталгаажуулах
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default SignUp;
